import { render, staticRenderFns } from "./FullBleedLayout.vue?vue&type=template&id=ffdf2a22&"
import script from "./FullBleedLayout.vue?vue&type=script&lang=js&"
export * from "./FullBleedLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports